import { z } from 'zod';

/**
 * 관제 화면 로그인 (51회차).
 *
 * 내부 API라 `version`을 두지 않는다(`responses.ts` 머리 주석과 같은 이유). 콘솔이 이 파일을
 * 소스째 번들하므로 `node:*` import를 넣지 않는다.
 *
 * 계정은 설정값 하나(`APM_AUTH_USER`·`APM_AUTH_PASSWORD`)이거나, 52회차부터 계정 파일
 * (`APM_AUTH_USERS`)의 여럿이다. 계정마다 **볼 서비스 목록**이 있고 관리자는 전체를 본다.
 * 판정은 언제나 서버가 한다. 화면은 이 값으로 선택기·메뉴를 그릴 뿐이다. 해시는 없다.
 */

/** `POST /api/auth/login` 본문. 길이 상한은 본문 파서 상한(1MB)과 별도로 잡는 오타 방지다 */
export const LoginRequest = z.object({
  username: z.string().min(1).max(200),
  password: z.string().min(1).max(200),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

/** 로그인한 세션 하나. 로그인 응답과 `GET /api/auth/me`가 같은 모양을 쓴다 */
export const SessionInfo = z.object({
  /** 계정 이름 */
  username: z.string().min(1),
  /** 로그인한 시각. epoch ms */
  loggedInAt: z.number().int().nonnegative(),
  /**
   * 관리자인가 (52회차). 관리자는 모든 서비스와 서비스에 묶이지 않는 자리(DB 감시·저장소·
   * 관제 서버·토큰 발급·규칙 편집)를 본다. 51회차 서버는 이 칸을 안 보내므로 그때처럼 전체다
   */
  admin: z.boolean().default(true),
  /**
   * 볼 수 있는 서비스(`service.name` 원문). 관리자면 비어 있고 뜻이 없다(전체).
   * **로그인한 시점의 값이다.** 그 뒤 계정 파일이 바뀌어도 다시 로그인해야 바뀐다
   */
  services: z.array(z.string()).default([]),
});
export type SessionInfo = z.infer<typeof SessionInfo>;

/**
 * `GET /api/auth/me`.
 *
 * 로그인이 켜져 있는데 세션이 없으면 이 응답이 아니라 401이다(세션 문이 막는다).
 * `APM_AUTH_ENABLED=false`면 `authEnabled: false`만 온다 — 화면이 로그인 화면과 로그아웃 단추를
 * 그리지 않게 알려 주는 자리다.
 */
export const AuthMeResult = z.object({
  authEnabled: z.boolean(),
  session: SessionInfo.optional(),
});
export type AuthMeResult = z.infer<typeof AuthMeResult>;
